export default "__VITE_ASSET__CBVBwMZ3__"